<template>
  <div>
    <SmallTitle text="Period" />
    <Chip
      v-for="range in Object.values(dateRanges)"
      :key="`range-${range}`"
      :title="range === dateRanges.Custom ? formattedDatesRange : $t(`accountPage.dateRanges.${range}`)"
      :value="range"
      name="range"
      :checked="range === selectedDateRangeType"
      v-on:click="range === dateRanges.Custom ? showCalendar() : setPredefinedRangeDate(range)"
    />

    <Modal :isShow="isShowModal" v-on:close="cancelModal" v-on:accept="acceptModal">
      <div class="py-3">
        <flat-pickr
          v-model="date"
          :config="calendarConfig"
          class="d-none"
          placeholder="Select date"
          name="date"
        ></flat-pickr>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import { dateRanges } from '../../../constants'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import SmallTitle from '../../elements/SmallTitle'
import Chip from '../../elements/Chip'
import { SET_PERSONAL_STATE_VALUE } from '../../../store/modules/personal/variables'

export default {
  data() {
    return {
      isShowModal: false,
      calendarConfig: {
        mode: 'range',
        maxDate: 'today',
        inline: true,
        theme: 'dark'
      },
      date: null,
      dateRanges
    }
  },
  components: {
    flatPickr,
    SmallTitle,
    Chip
  },
  computed: {
    ...mapGetters('personal', ['formattedDatesRange', 'selectedDateRangeType', 'selectedDateRangeValue', 'arrayOfDatesRange'])
  },
  mounted() {
    if (this.selectedDateRangeType && !this.selectedDateRangeValue) {
      this.setPredefinedRangeDate(this.selectedDateRangeType)
    }
  },
  methods: {
    ...mapMutations('personal', [SET_PERSONAL_STATE_VALUE]),
    showCalendar() {
      this.isShowModal = true
    },
    cancelModal() {
      if (!this.selectedDateRangeValue) {
        this.date = null
        this[SET_PERSONAL_STATE_VALUE](['selectedDateRangeValue', this.date])
        localStorage.setItem('selectedDateRangeValue', this.date)
      }
      this.closeModal()
    },
    acceptModal() {
      if (this.date) {
        this[SET_PERSONAL_STATE_VALUE](['selectedDateRangeValue', this.date])
        this[SET_PERSONAL_STATE_VALUE](['selectedDateRangeType', dateRanges.Custom])
        localStorage.setItem('selectedDateRangeValue', this.date)
        localStorage.setItem('selectedDateRangeType', dateRanges.Custom)
      }
      this.closeModal()
    },
    closeModal() {
      this.isShowModal = false
    },
    setPredefinedRangeDate(rangeType) {
      const dateFrom = new Date()
      const toDateString = date => new Date(date).toISOString().slice(0, 10)

      switch (rangeType) {
        case dateRanges.Year:
          dateFrom.setFullYear(dateFrom.getFullYear() - 1)
          break
        case dateRanges.HalfYear:
          dateFrom.setMonth(dateFrom.getMonth() - 6)
          break
        case dateRanges.Month:
          dateFrom.setMonth(dateFrom.getMonth() - 1)
          break
        case dateRanges.Week:
          dateFrom.setDate(dateFrom.getDate() - 7)
          break
      }
      const datesString = `${toDateString(dateFrom)} to ${toDateString(new Date())}`

      this[SET_PERSONAL_STATE_VALUE](['selectedDateRangeValue', datesString])
      this[SET_PERSONAL_STATE_VALUE](['selectedDateRangeType', rangeType])
      localStorage.setItem('selectedDateRangeValue', datesString)
      localStorage.setItem('selectedDateRangeType', rangeType)
      this.date = null
    }
  }
}
</script>

<style lang="stylus">
$selectedDayBackground = #212121;
$calendarBorderColor = #ffffff;

@require '~flatpickr/src/style/flatpickr.styl';

.flatpickr-calendar {
  border: 1px solid var(--body-bg);
  box-shadow: none;
  margin: auto;
  background-color: var(--body-bg);
}

.is-danger .flatpickr-calendar {
  border-color: #D90000;
}

.custom-period-chips {
  width: 190px;
  vertical-align: top;
}

.flatpickr-months .flatpickr-prev-month, .flatpickr-months .flatpickr-month, .flatpickr-months .flatpickr-next-month {
  color: var(--body-color);

  svg {
    fill: var(--body-color);
  }
}

span.flatpickr-weekday {
  color: var(--headings-color);
}

.flatpickr-day {
  color: var(--body-color);
}

.flatpickr-day.inRange, .flatpickr-day.prevMonthDay.inRange, .flatpickr-day.nextMonthDay.inRange {
  background: var(--element-bg-darker);
  border-color: var(--element-bg-darker);
  box-shadow: -5px 0 0 var(--element-bg-darker), 5px 0 0 var(--element-bg-darker);
}

.flatpickr-day.startRange, .flatpickr-day.endRange {
  background: var(--body-color);
  border-color: var(--body-color);
  color: var(--element-bg);

  &:hover {
    background: var(--body-color);
    border-color: var(--body-color);
    color: var(--element-bg);
  }
}
</style>
